import { SYSFormField } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

export type NewServiceStep3FormFieldKeys =
  | "objectBuildingType"
  | "agbConfirmation"
  | "generalRemarks"
  | "orderReference"
export let NewServiceStep3FormFieldsDef: {
  [key in NewServiceStep3FormFieldKeys]: SYSFormField
} = {
  agbConfirmation: {
    value: false,
    ui: {
      labelTranslationKey: "NewServiceConfirmationAGB",
      visible: "true",
    },
    type: "bool",
  },

  objectBuildingType: {
    list: {
      valueField: "BuildingType",
      displayField: "BuildingDesc",
      mode: "Select",
      acceptOnlyListValues: true,
      displayValueField: false,
    },
    schema: { nullable: false },
    value: "",
    type: "text",
    ui: { labelTranslationKey: "NewServiceBuildingType" },
  },

  generalRemarks: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceGeneralRemarks",
    },
  },
  orderReference: {
    value: "",
    ui: {
      labelTranslationKey: "NewServiceOrderReference",
    },
  },
}
